<!--<lib-filter-list [configService]="orderAnalyticsConfigService"></lib-filter-list>-->
<lib-order-analytics-standalone></lib-order-analytics-standalone>
<!--<hr>-->
<!-- Removed order finder from order analytics AK 240131-->
<!-- <lib-filter-list [configService]="orderFinderConfigService"></lib-filter-list> -->
